
export class ChangePassword{

    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Home/model/ChangePassword.ts